import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const BCEconomicSector = React.lazy(() =>
    import('../BCEconomicSector')
);
const bCEconomicSectorRoutesRegistry = [
    {
        path: PAGE_URL.B_C_ECONOMIC_SECTOR_PAGE,
        element: <BCEconomicSector />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default bCEconomicSectorRoutesRegistry;
